var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_call_svg__clip0_25045_57330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 11.521v2a1.332 1.332 0 01-1.453 1.333 13.193 13.193 0 01-5.754-2.046 13 13 0 01-4-4 13.193 13.193 0 01-2.046-5.78A1.333 1.333 0 012.74 1.574h2a1.333 1.333 0 011.334 1.147 8.56 8.56 0 00.466 1.873 1.333 1.333 0 01-.3 1.407l-.846.847a10.667 10.667 0 004 4L10.24 10a1.333 1.333 0 011.407-.3 8.56 8.56 0 001.873.467 1.333 1.333 0 011.147 1.353z",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_call_svg__clip0_25045_57330"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .241)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/icon_call.cce55db1.svg";
export { SvgIconCall as ReactComponent };